import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MetricTooltip } from './metric-tooltip';

interface MetricCardProps {
  metricKey?: string;
  label: string;
  value: string | number;
  subValue?: string;
  icon?: React.ReactNode;
  status?: 'healthy' | 'warning' | 'critical' | 'unknown';
}

export function MetricCard({ metricKey, label, value, subValue, icon }: MetricCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">
          <span className="flex items-center gap-2">
            {label}
            {metricKey && <MetricTooltip metricKey={metricKey} />}
          </span>
        </CardTitle>
        {icon}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        {subValue && <p className="text-muted-foreground text-xs">{subValue}</p>}
      </CardContent>
    </Card>
  );
}
